export default "__VITE_ASSET__CqOXZbdf__"